import { useEffect, useRef, useState } from "react";

export const useYouTubePlayer = () => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data || "{}");
        if (data.event === "onStateChange") {
          if (data.info === 1) setIsPlaying(true); // Playing
          else if (data.info === 2 || data.info === 0) setIsPlaying(false); // Paused or Ended
        }
      } catch (err) {
        console.error("Erreur de parsing du message YouTube :", err);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const pauseVideo = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage(
        JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: [],
        }),
        "*"
      );
    }
  };

  return { iframeRef, isPlaying, pauseVideo };
};
